import { render, staticRenderFns } from "./Emprunteur.vue?vue&type=template&id=20702ade&"
import script from "./Emprunteur.vue?vue&type=script&lang=js&"
export * from "./Emprunteur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports